import { httpClient } from "../http/httpClient";

interface GetWithdrawProofParams {
  pixTransferKey: string;
}

export async function getWithdrawProof({ pixTransferKey }: GetWithdrawProofParams): Promise<Blob> {
  const { data } = await httpClient.get<Blob>(`/withdraw/proof/${pixTransferKey}`, {
    responseType: 'blob',
  });

  return data;
}